<template>
  <div class="my-navigation2-div">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" style="width: 100%;" :stretch="true">
      <el-tab-pane v-for="(item,index1) in items" :key="index1" :label="item.name" :name="'pane'+(index1+1)" style="width: 14.28%;color: #707070;">
        <table class="my-navigation2-table">
          <tr>
            <td v-if="showList[0]">
              <img v-lazy="showList[0].path" :name="showList[0].name" class="my-navigation2-img" @click="navigationClick(showList[0].id,showList[0].nid)"
                :title="showList[0].name" />
            </td>
            <td v-if="showList[1]">
              <img v-lazy="showList[1].path" :name="showList[1].name" class="my-navigation2-img" @click="navigationClick(showList[1].id,showList[1].nid)"
                :title="showList[1].name" />
            </td>
            <td v-if="showList[2]">
              <img v-lazy="showList[2].path" :name="showList[2].name" class="my-navigation2-img" @click="navigationClick(showList[2].id,showList[2].nid)"
                :title="showList[2].name" />
            </td>
            <td v-if="showList[3]">
              <img v-lazy="showList[3].path" :name="showList[3].name" class="my-navigation2-img" @click="navigationClick(showList[3].id,showList[3].nid)"
                :title="showList[3].name" />
            </td>
          </tr>
          <tr>
            <td v-if="showList[0]">
              <router-link :to="'/item/desc?itemId='+showList[0].id+'&nid='+showList[0].nid"><span class="my-navigation2-span2">{{showList[0].name}}</span></router-link>
            </td>
            <td v-if="showList[1]">
              <router-link :to="'/item/desc?itemId='+showList[1].id+'&nid='+showList[1].nid"><span class="my-navigation2-span2">{{showList[1].name}}</span></router-link>
            </td>
            <td v-if="showList[2]">
              <router-link :to="'/item/desc?itemId='+showList[2].id+'&nid='+showList[2].nid"><span class="my-navigation2-span2">{{showList[2].name}}</span></router-link>
            </td>
            <td v-if="showList[3]">
              <router-link :to="'/item/desc?itemId='+showList[3].id+'&nid='+showList[3].nid"><span class="my-navigation2-span2">{{showList[3].name}}</span></router-link>
            </td>
          </tr>
          <tr>
            <td v-if="showList[4]">
              <img v-lazy="showList[4].path" :name="showList[4].name" class="my-navigation2-img" @click="navigationClick(showList[4].id,showList[4].nid)"
                :title="showList[4].name" />
            </td>
            <td v-if="showList[5]">
              <img v-lazy="showList[5].path" :name="showList[5].name" class="my-navigation2-img" @click="navigationClick(showList[5].id,showList[5].nid)"
                :title="showList[5].name" />
            </td>
            <td v-if="showList[6]">
              <img v-lazy="showList[6].path" :name="showList[6].name" class="my-navigation2-img" @click="navigationClick(showList[6].id,showList[6].nid)"
                :title="showList[6].name" />
            </td>
            <td v-if="showList[7]">
              <img v-lazy="showList[7].path" :name="showList[7].name" class="my-navigation2-img" @click="navigationClick(showList[7].id,showList[7].nid)"
                :title="showList[7].name" />
            </td>
          </tr>
          <tr>
            <td v-if="showList[4]">
              <router-link :to="'/item/desc?itemId='+showList[4].id+'&nid='+showList[4].nid"><span class="my-navigation2-span2">{{showList[4].name}}</span></router-link>
            </td>
            <td v-if="showList[5]">
              <router-link :to="'/item/desc?itemId='+showList[5].id+'&nid='+showList[5].nid"><span class="my-navigation2-span2">{{showList[5].name}}</span></router-link>
            </td>
            <td v-if="showList[6]">
              <router-link :to="'/item/desc?itemId='+showList[6].id+'&nid='+showList[6].nid"><span class="my-navigation2-span2">{{showList[6].name}}</span></router-link>
            </td>
            <td v-if="showList[7]">
              <router-link :to="'/item/desc?itemId='+showList[7].id+'&nid='+showList[7].nid"><span class="my-navigation2-span2">{{showList[7].name}}</span></router-link>
            </td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    getNavigationMenu,
    getNavigation
  } from '@/api/navigation.js'

  export default {
    name: "Navigation2",
    props: ['number'],
    data: function() {
      return {
        activeName: 'pane1',
        items: [],
        showList: [],
      }
    },
    methods: {
      handleClick(tab, event) {
        getNavigation("item/get?nid=" + this.$data.items[Number(tab.index)].id, this);
      },
      navigationClick(itemId, nid) {
        this.$router.push({
          path: '/item/desc?itemId=' + itemId + '&nid=' + nid
        })
      }
    },
    created() {
      getNavigationMenu("navigation/get?pagesize=7&number=" + this.number, this.$data);
    }
  }
</script>

<style>
  .my-navigation2-div {
    width: 100%;
    margin: 0 auto;
  }

  .my-navigation2-table {
    width: 100%;
  }

  .my-navigation2-span2 {
    color: steelblue;
    font-size: 18px;
  }

  .my-navigation2-img {
    width: 216px;
    height: 240px;
    cursor: pointer;
    padding: 0px 34.5px 0px 34.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Navigation2.vue